import { MainV3ApiBase } from './base';
import { UserTutorialCompletionIndexView, UserTutorialCompletionKey } from '../types/userTutorialCompletions';

export const UserTutorialCompletionsApi = {
    base() {
        return MainV3ApiBase.appendPath('users/current/user_tutorial_completions');
    },
    findAll(): Promise<UserTutorialCompletionIndexView[]> {
        return this.base().get();
    },
    create(key: UserTutorialCompletionKey): Promise<UserTutorialCompletionIndexView> {
        return this.base().post({ key: key });
    },
};
